let apiHost;
const hostname = window && window.location && window.location.hostname;
if (hostname === "cdktag.cdk.com") {
  apiHost = "https://cdktag.cdk.com";
} else if (hostname === "c03pitdesk629.ds.ad.adp.com") {
  apiHost = "http://c03pitdesk629.ds.ad.adp.com";
} else {
  apiHost = "http://c03ditdesk968.ds.ad.adp.com";
}

export const API_BASE_URL = apiHost;
